/* eslint-disable */
// AUTO-GENERATED by scripts/gen-config.js from .env.harrybrown.yml — DO NOT EDIT OR COMMIT.
// Typed as a loose bag (matching the prior react-native-ultimate-config default
// export); app/config.ts re-types each field into the curated `config` object.
const config: Record<string, any> = {
  "APP_NAME": "Harry Brown",
  "BUNDLE_ID": {
    "ios": "com.myfoodlink.ios.harrybrown",
    "android": "au.com.lmg.harrybrown",
    "web": "NOT_APPLICABLE"
  },
  "BUNDLE_VERSION": 1,
  "MARKETING_VERSION": "3.4.20",
  "WHITE_LABEL_ID": "harrybrown",
  "APP_STORE_ID": "1484424287",
  "BASE_TENANT": "HB",
  "BASE_URL": "https://mw.lmg-bw.au",
  "TILL_GATEWAY": "https://gateway.tillpayments.com/js/integrated/payment.1.3.min.js",
  "HOST_DOMAIN": "harrybrown.com.au",
  "DEFAULT_STORE": "C000131774",
  "DEFAULT_STORE_STATE": "QLD",
  "SUPPORT_EMAIL": "online@harrybrown.com.au",
  "GIFT_CARD_STORE": "harrybrowngiftstore",
  "GIFT_CARDS_PROMOTION_ID": "HarryBrown-gift-card",
  "FF_IS_GIFT_CARDS_ENABLED": true,
  "FF_GIFT_CARD_ALL_STORES": false,
  "ONESIGNAL_APP_ID": "eb36fa69-7af9-49c1-8c5e-dbe8ef7093d6",
  "OTEL_ENABLED": true,
  "OTEL_SERVICE_NAME": "frontend-harrybrown",
  "OTEL_SAMPLE_RATE": 1,
  "OTEL_DEBUG": false,
  "USE_API_PROXY": true,
  "SENTRY_DSN": "https://b8167d415374b364ba8b8d41ef3fa710@o4504137358442496.ingest.us.sentry.io/4510655432097792",
  "APPLE_PAY_MERCHANT_NAME": "Harry Brown",
  "APPLE_PAY_MERCHANT_ID": "merchant.com.lmg.production"
};

export default config;
